import { useState, useCallback, useMemo } from "react";
import type { ReactNode } from "react";
import { BreadcrumbContext } from "./breadcrumbContext";

export function BreadcrumbProvider({ children }: { children: ReactNode }) {
  const [overrides, setOverridesState] = useState<Record<string, string>>({});
  const [contentOverrides, setContentOverridesState] = useState<Record<string, ReactNode>>({});

  const setOverrides = useCallback(function setOverrides(newOverrides: Record<string, string>) {
    setOverridesState(newOverrides);
  }, []);

  const setContentOverrides = useCallback(function setContentOverrides(
    newContentOverrides: Record<string, ReactNode>,
  ) {
    setContentOverridesState(newContentOverrides);
  }, []);

  const value = useMemo(
    () => ({ overrides, setOverrides, contentOverrides, setContentOverrides }),
    [overrides, setOverrides, contentOverrides, setContentOverrides],
  );

  return (
    <BreadcrumbContext value={value}>
      {children}
    </BreadcrumbContext>
  );
}
